// extracted by mini-css-extract-plugin
export var marginNegative = "_5c-5 _5c-3 _5c-1";
export var marginPositive = "_5c-4 _5c-3 _5c-1";
export var modalContent = "_5c-6";
export var samplesTable = "_5c-8";
export var samplesTableContainer = "_5c-7";
export var statBox = "_5c-a";
export var tableCell = "_5c-1";
export var tableCellCenter = "_5c-2 _5c-1";
export var tableCellRight = "_5c-3 _5c-1";
export var tableHeader = "_5c-0";
export var trackingNumber = "_5c-9";